export const FETCH_INVESTIGATORS_WORKLOAD = 'FETCH_INVESTIGATORS_WORKLOAD';
export const FETCH_INVESTIGATORS_WORKLOAD_SUCCESS =
  'FETCH_INVESTIGATORS_WORKLOAD_SUCCESS';
export const FETCH_INVESTIGATORS_WORKLOAD_FAIL =
  'FETCH_INVESTIGATORS_WORKLOAD_FAIL';

export const fetchInvestigatorWorkload = (dashboardFilter) => ({
  type: FETCH_INVESTIGATORS_WORKLOAD,
  payload: dashboardFilter
});

export const fetchInvestigatorWorkloadSuccess = (investigators) => ({
  type: FETCH_INVESTIGATORS_WORKLOAD_SUCCESS,
  payload: investigators
});

export const fetchInvestigatorWorkloadFail = () => ({
  type: FETCH_INVESTIGATORS_WORKLOAD_FAIL
});
